import {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_khaugali/partials'
import ExpenseMasterPage from '../modules/expense_page/ExpenseMasterPage'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'

export function PrivateRoutes() {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const EmployeeMasterPage = lazy(
    () => import('../modules/employee-page/employee-master-page/EmployeeMasterPage')
  )
  const FieldExecutiveMasterPage = lazy(
    () => import('../modules/employee-page/Field-executive-master-page/FieldExecutiveMasterPage')
  )
  const ClientMasterPage = lazy(
    () => import('../modules/client-page/client-master-page/ClientMasterPage')
  )
  const ProductCategoryMasterPage = lazy(
    () => import('../modules/product-page/product-category-master-page/ProductCategoryMasterPage')
  )
  const ProductMasterPage = lazy(
    () => import('../modules/product-page/product-master-page/ProductMasterPage')
  )
  const TableMasterPage = lazy(
    () => import('../modules/master_page/table_master_page/TableMasterPage')
  )
  const StateMasterPage = lazy(
    () => import('../modules/master_page/state_master_page/StateMasterPage')
  )
  const CityMasterPage = lazy(
    () => import('../modules/master_page/city_master_page/CityMasterPage')
  )
  const AreaMasterPage = lazy(
    () => import('../modules/master_page/area_master_page/AreaMasterPage')
  )
  const BannerMasterPage = lazy(
    () => import('../modules/master_page/banner_master_page/BannerMasterPage')
  )
  const ExpenseTypePage = lazy(
    () => import('../modules/master_page/expense_master_page/ExpenseTypePage')
  )
  const TaxsPage = lazy(() => import('../modules/taxs-page/TaxsPage'))
  const NewAreaRequestPage = lazy(
    () => import('../modules/requests-page/new-area-request-page/NewAreaRequestPage')
  )
  const NewCityRequestPage = lazy(
    () => import('../modules/requests-page/new-city-request-page/NewCityRequestPage')
  )
  const NewSocietyRequestPage = lazy(
    () => import('../modules/requests-page/new-society-request-page/NewSocietyRequestPage')
  )

  // const HolidaysList = lazy(() => import('../modules/holidays/Holidays'))

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/dashboard' component={DashboardWrapper} />
        <Route path='/builder' component={BuilderPageWrapper} />
        <Route path='/crafted/pages/profile' component={ProfilePage} />
        <Route path='/crafted/pages/wizards' component={WizardsPage} />
        <Route path='/crafted/widgets' component={WidgetsPage} />
        <Route path='/crafted/account' component={AccountPage} />
        <Route path='/apps/chat' component={ChatPage} />
        <Route path='/menu-test' component={MenuTestPage} />
        {/* <Route path='/users' component={UserList} /> */}
        <Route path='/employee/employee' component={EmployeeMasterPage} />
        <Route path='/employee/fieldExecutive' component={FieldExecutiveMasterPage} />
        <Route path='/client' component={ClientMasterPage} />
        <Route path='/product/productCategory' component={ProductCategoryMasterPage} />
        <Route path='/product/product' component={ProductMasterPage} />
        <Route path='/request/newAreaReq' component={NewAreaRequestPage} />
        <Route path='/request/newCityReq' component={NewCityRequestPage} />
        <Route path='/request/newSocietyReq' component={NewSocietyRequestPage} />
        <Route path='/tax' component={TaxsPage} />
        <Route path='/master/table' component={TableMasterPage} />
        <Route path='/master/state' component={StateMasterPage} />
        <Route path='/master/city' component={CityMasterPage} />
        <Route path='/master/area' component={AreaMasterPage} />
        <Route path='/master/banner' component={BannerMasterPage} />
        <Route path='/master/expense' component={ExpenseTypePage} />
        <Route path='/expense' component={ExpenseMasterPage} />

        <Redirect from='/' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
